
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/search",
      function () {
        return require("private-next-pages/[region]/[lang]/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/search"])
      });
    }
  